import { Button } from '@components/Button';
import { CloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';
import { JoykitIcon } from '@components/JoykitIcon';
import { Text } from '@components/typography';
import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import styled from 'styled-components';

export const StyledCloseButton = styled(Button)`
  position: absolute;
  top: ${themeSpace(1)};
  right: ${themeSpace(1)};
  padding: ${themeSpace(3)};
  background: none;
  border: none;
  width: 60px;
  height: 60px;
  background: ${themeColor('white')};
  border-radius: ${themeSpace(4)};
  display: flex;
  align-items: center;
  justify-content: center;
  :focus {
    outline: none;
  }
  ${themeMediaQuery('below_sm')} {
    top: ${themeSpace(1)};
    right: ${themeSpace(1)};
  }
`;

export const StyledCloseIcon = styled(JoykitIcon)`
  width: ${themeSpace(5)};
  height: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    width: ${themeSpace(4)};
    height: ${themeSpace(4)};
  }
`;

export const StyledContentContainer = styled(Flex)`
  flex-direction: row;
  gap: ${themeSpace(7)};
  overflow-y: auto;
  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  max-height: 336px;
  ${themeMediaQuery('below_sm')} {
    width: 40%;
    min-width: 150px;
  }
`;

export const StyledContentWrapper = styled(Flex)`
  flex-direction: column;
  ${themeMediaQuery('below_sm')} {
    align-items: center;
    text-align: center;
  }
`;

export const StyledStep = styled(Flex)`
  height: ${themeSpace(9)};
  width: ${themeSpace(9)};
  border-radius: 50%;
  background-color: ${themeColor('accentBlue4')};
  justify-content: center;
  align-items: center;
  color: ${themeColor('white')};
  margin-bottom: ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    height: ${themeSpace(8)};
    width: ${themeSpace(8)};
    flex-shrink: 0;
    margin-bottom: 0;
  }
`;

export const StyledFlex = styled(Flex)`
  position: relative;
  background-color: ${themeColor('white')};
  border-radius: ${themeSpace(5)};
  padding: ${themeSpace(11)} ${themeSpace(10)} ${themeSpace(11)} ${themeSpace(7)};
  flex-direction: row;
  gap: ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    align-items: center;
    padding: ${themeSpace(9)} ${themeSpace(7)};
  }
`;

export const StyledEyebrow = styled(Text)`
  margin-bottom: ${themeSpace(4)};
  ${themeMediaQuery('below_sm')} {
    ${themeVariant('featureHed17')}
    margin-bottom: 0;
  }
`;

export const StyledTitle = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    ${themeVariant('dek24')}
  }
`;

export const StyledHeadWrapper = styled(Flex)`
  flex-direction: column;
  ${themeMediaQuery('below_sm')} {
    flex-direction: row;
    align-items: center;
    gap: ${themeSpace(3)};
    margin-bottom: ${themeSpace(4)};
  }
`;
